export default __webpack_public_path__ + "measure-500-cdfd6e7c9afc07d8369b9575f696d49b.png";